<template>
  <div>
    <div class="modal-content">
      <div class="modal-body">
        <ConfirmLayout title="Cancel Quote" bs-dismiss @close="closeModal">
          Are you sure you want to cancel this quote? please enter a
          reason for cancellation to continue.
          <!-- reason + TradeCall fee question -->
          <div class="mt-3 text-left">
            <h6 class="my-1 text-[14px] text-[#999999]">
              Reason for cancellation
            </h6>
            <textarea v-model="reason"
              class="form-control resize-none focus:!outline-none focus:!border-[#EFEFEF] !rounded-[10px] !text-[14px] border-1 border-[#EFEFEF] myTextHere"
              placeholder="Enter Text here..." ></textarea>
          </div>
          <div v-if="
            quoteDetail &&
            quoteDetail.partner_info &&
            quoteDetail.partner_info.is_tradecall_fee_applicable == 1
          " class="mt-4 text-left">
            <h6 class="text-[16px] font-normal text-[#666666]">
             A TradeCall fee for
              {{ quoteDetail.partner_info.tradecall_fee_text }} is
              applicable on this claim. Have you collected the TradeCall
              free from {{ quoteDetail.consumer.full_name }} ?
            </h6>
            <div class="flex gap-8 items-center">
              <label class="flex items-center gap-2 cursor-pointer select-none text-base text-[#666666]">
                <input type="radio" v-model="check" value="1" class="hidden" />
                <span
                  class="w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center transition-colors duration-150"
                  :class="check === '1' ? 'border-[#7695FF]' : 'border-gray-300'">
                  <span class="w-[10px] h-[10px] rounded-full bg-[#7695FF] transition-transform duration-150"
                    :class="check === '1' ? 'scale-100' : 'scale-0'">
                  </span>
                </span>
                Yes
              </label>

              <label class="flex items-center gap-2 cursor-pointer select-none text-base text-[#666666]">
                <input type="radio" v-model="check" value="0" class="hidden" />
                <span
                  class="w-[20px] h-[20px] rounded-full border-2 flex items-center justify-center transition-colors duration-150"
                  :class="check === '0' ? 'border-[#7695FF]' : 'border-gray-300'">
                  <span class="w-[10px] h-[10px] rounded-full bg-[#7695FF] transition-transform duration-150"
                    :class="check === '0' ? 'scale-100' : 'scale-0'">
                  </span>
                </span>
                No
              </label>
            </div>
          </div>
          <template #actions>
            <button type="button" class="fxConfirmBtnOutline" @click="closeModal">
              Dismiss
            </button>
            <button type="button" class="fxConfirmBtn" @click="confirm()">
              Cancel Quote
            </button>
          </template>
        </ConfirmLayout>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
import ConfirmLayout from "../confirmDialog/ConfirmLayout.vue";
const toast = useToast();

export default {
  components: { ConfirmLayout },

  data() {
    return {
      check: "",
      reason: "",
    };
  },
  computed: {
    ...mapGetters(["quoteDetail", "apptDetail"]),
  },

  watch: {},

  mounted() { },

  methods: {
    ...mapActions(["setCommponent"]),

    editQuoteClicked() {
      this.setCommponent("QuoteItems");
    },

    closeModal() {
      this.check = "";
      this.reason = "";
      this.$emit("event", "close");
    },

    confirm() {
      if (this.reason.length <= 0) {
        toast.error("Reason field is required.");
      } else if (
        this.quoteDetail.partner_info &&
        this.quoteDetail.partner_info.is_tradecall_fee_applicable == 1 &&
        this.check.length <= 0
      ) {
        toast.error("Please confirm have you collected the TradeCall fee.");
      } else {
        let ch = this.check.length <= 0 ? "0" : this.check;
        this.$emit("event", "confirm", {
          is_tradecall_fee_collected: ch,
          reason: this.reason,
        });
        this.check = "";
        this.reason = "";
      }
    },
  },
};
</script>

<style>
.modals-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modals {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.continue-popup .modal-header {
  padding: 0;
  border: none;
}

.continue-popup {
  border-radius: 12px;
  box-shadow: 0 0 10px #fff;
  border: none;
}

.textCard {
  font-size: 17px !important;
}

.btnClose {
  position: absolute;
  background: none;
  right: 10px;
  padding: 0;
  border: none;
  border-radius: 50px;
  z-index: 9;
  font-weight: bold;
}

.myCheckText {
  color: #ff5b01;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.myCheck {
  height: 15px;
  width: 15px;
  accent-color: #ff5b01;
}

.disBtn {
  background-color: #003087 !important;
}
</style>